import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/BibleVerse.css';


const BibleVerse = () => {
    const { t } = useLanguage();

    return (
        <section className='bible-verse-section'>
            <div id="top-pad" className='bible-verse-content'>
                <h2 className='verse-headings' style={{textAlign:"center"}}>{t('bibleVerse.line1')}</h2>
                <h2 className='verse-headings' style={{textAlign:"center"}}>{t('bibleVerse.line2')}</h2>
                <h2 className='verse-headings' style={{textAlign:"center"}}>{t('bibleVerse.line3')}</h2>
                <p className='verse-scripture' style={{textAlign:"center"}}>
                    {t('bibleVerse.verse')}
                    <span className="verse-attribution">{t('bibleVerse.attribution')}</span>
                </p>
            </div>
        </section>
    );
}

export default BibleVerse;
